export default __webpack_public_path__ + "static/media/1.bf7449da.jpg";